import { useCallback, useEffect, useState } from 'react';
import { getAllSkusWithNames } from '../services/SKUListAPI';

interface UseSkuNameCatalogResult {
  resolveNameForSku: (sku: string) => string;
  rememberName: (sku: string, name: string) => void;
}

/**
 * Loads RSV SKU → display-name map for Search Warehouse / Print Label Name autofill.
 */
export function useSkuNameCatalog(): UseSkuNameCatalogResult {
  const [skuNameBySku, setSkuNameBySku] = useState<Record<string, string>>({});

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const items = await getAllSkusWithNames();
      if (cancelled) return;
      const map: Record<string, string> = {};
      for (const item of items) {
        map[item.sku.toUpperCase()] = item.name;
      }
      setSkuNameBySku(map);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const resolveNameForSku = useCallback(
    (sku: string): string => skuNameBySku[sku.toUpperCase()] ?? '',
    [skuNameBySku],
  );

  const rememberName = useCallback((sku: string, name: string): void => {
    setSkuNameBySku((prev) => ({ ...prev, [sku.toUpperCase()]: name }));
  }, []);

  return { resolveNameForSku, rememberName };
}
